module.exports = __webpack_public_path__ + "static/011-67fd3106cd18aba57a10108966d70dbf.jpg";